import React from "react";
import { graphql } from "gatsby";
import Layout from "../../components/Layout";
import WithI18next from "../../components/WithI18next";
import CampaignInfoLayout, {
  CAMPAIGN_TYPES,
} from "../../layouts/CampaignLayout";

const CampaignsPage = ({ data, t, location }) => {
  const search = new URLSearchParams(location.search);
  const param = search.get("type");
  const isTypeExisted = Object.values(CAMPAIGN_TYPES).indexOf(param) >= 0;
  const campaignType = isTypeExisted ? param : CAMPAIGN_TYPES.NEW_USERS;

  return (
    <Layout
      title={t("campaigns.seo.title")}
      description={t("campaigns.seo.description")}
    >
      <CampaignInfoLayout data={data} campaignType={campaignType} />
    </Layout>
  );
};

export default WithI18next()(CampaignsPage);

export const query = graphql`
  query ($wpLocale: String!, $wpGlobalConfig: String!) {
    newUserCampaigns: allWpCampaignItem(
      filter: {
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
        language: { locale: { eq: $wpLocale } }
        acfShowOnPage: { showStatus: { ne: "hide" } }
        categories: {
          nodes: { elemMatch: { slug: { eq: "new-zipmex-users" } } }
        }
      }
    ) {
      edges {
        node {
          title
          slug
          acfCampaignDate {
            campaignStartDate
            campaignEndDate
          }
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 450, layout: CONSTRAINED)
                }
              }
            }
          }
        }
      }
    }
    existingUserCampaigns: allWpCampaignItem(
      filter: {
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
        language: { locale: { eq: $wpLocale } }
        acfShowOnPage: { showStatus: { ne: "hide" } }
        categories: {
          nodes: { elemMatch: { slug: { eq: "existing-zipmex-users" } } }
        }
      }
    ) {
      edges {
        node {
          title
          slug
          acfCampaignDate {
            campaignStartDate
            campaignEndDate
          }
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 450, layout: CONSTRAINED)
                }
              }
            }
          }
        }
      }
    }
  }
`;
